import Global from './Global.json';

const exports = {
    Global,
};

export default exports;
